import React from 'react';

import GlobalMobileMenuNavigationButtonContainer from 'dpl/containers/GlobalMobileMenu/GlobalMobileMenuNavigationButtonContainer';

export default function MobileNavigationMenuButton() {
  return <GlobalMobileMenuNavigationButtonContainer />;
}
